import {
  ADDRESS_BOOK_CONTACT_FETCH_STARTED,
  ADDRESS_BOOK_CONTACT_FETCH_SUCCEEDED,
  ADDRESS_BOOK_CONTACT_FETCH_FAILED,
  ADDRESS_BOOK_CONTACT_CLEAR,
  SUCCESS
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { snackBarError } from '#action/fetch';
import { SubmissionError } from '#helper/submission-error';
import { history } from '#configureStore';
import { getRequestOptions } from '#helper';

let abortController = new AbortController();

export const fetchAddressbookContact = id => async dispatch => {
  try {
    abortController.abort();
    const addressbookContactUrl = webPortalApi.buildApiUrl(`addressbook/contact/${id}`);
    dispatch({
      type: ADDRESS_BOOK_CONTACT_FETCH_STARTED
    });
    abortController = new AbortController();
    const { signal } = abortController;
    const res = await fetch(addressbookContactUrl, { ...getRequestOptions(), signal });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }

    const response = await res.json();

    if (!res.ok) {
      const shallRedirect = [403, 404].includes(response.resStatus);

      dispatch(
        snackBarError({
          message: 'Error in request',
          ...response
        })
      );

      if (shallRedirect) {
        await history.push('/addressbook');
      }

      throw response;
    }

    dispatch({
      type: ADDRESS_BOOK_CONTACT_FETCH_SUCCEEDED,
      payload: response
    });
  } catch (e) {
    if (e.name === 'AbortError') {
      return;
    }
    dispatch({
      type: ADDRESS_BOOK_CONTACT_FETCH_FAILED,
      error: e
    });
  }
};

export const clear = () => dispatch => {
  abortController.abort();
  dispatch({
    type: ADDRESS_BOOK_CONTACT_CLEAR
  });
};

export const createAddressbookContact = contact => async dispatch => {
  try {
    const addressbookContactUrl = webPortalApi.buildApiUrl('addressbook/contact');
    const res = await fetch(addressbookContactUrl, {
      method: 'POST',
      body: JSON.stringify(contact),
      ...getRequestOptions()
    });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }

    dispatch({
      type: SUCCESS,
      payload: {
        message: 'Contact has been created'
      }
    });

    return await res.json();
  } catch (e) {
    dispatch(snackBarError({
      message: 'Error in request',
      ...e
    }));
    throw new SubmissionError(e);
  }
};

export const updateAddressbookContact = (contactId, contact) => async dispatch => {
  try {
    const addressbookContactUrl = webPortalApi.buildApiUrl(`addressbook/contact/${contactId}`);
    const res = await fetch(addressbookContactUrl, {
      method: 'PATCH',
      body: JSON.stringify(contact),
      ...getRequestOptions()
    });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }

    dispatch({
      type: SUCCESS,
      payload: {
        message: 'Contact has been updated'
      }
    });

    return await res.json();
  } catch (e) {
    dispatch(snackBarError({
      message: 'Error in request',
      ...e
    }));
    throw new SubmissionError(e);
  }
};

export const deleteAddressbookContact = contactId => async dispatch => {
  try {
    const addressbookContactUrl = webPortalApi.buildApiUrl(`addressbook/contact/${contactId}`);
    const res = await fetch(addressbookContactUrl, {
      method: 'DELETE',
      ...getRequestOptions()
    });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }

    dispatch({
      type: SUCCESS,
      payload: {
        message: 'Contact has been deleted'
      }
    });

    return await res.json();
  } catch (e) {
    dispatch(snackBarError({
      message: 'Error in request',
      ...e
    }));
    return null;
  }
};
